import useragent from 'useragent';

export function getBrowserFamily(family){
    const ua = useragent.parse(navigator.userAgent).family.toLowerCase()
    if(family)
        return ua.includes(family.toLowerCase())
    return ua
}

export default {
    getBrowserFamily
}